module.exports = __webpack_public_path__ + "static/pow_dz-a3166cf2f119d0ddc0ee31cca38be90b.png";